import { useState } from "react";
import FadeIn from "../components/FadeIn";
import { ME } from "../constants/portfolioData";

/**
 * ProjectsSection
 * Displays featured projects by default with a "Show more" toggle.
 */
const ProjectsSection = () => {
  const [showAll, setShowAll] = useState(false);

  const featured = ME.projects.filter((p) => p.featured);
  const extras   = ME.projects.filter((p) => !p.featured);
  const shown    = showAll ? ME.projects : featured;

  return (
    <>
      <style>{`
        .proj-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(330px, 1fr)); gap: 1.25rem; }
        .proj-card { background: var(--bg2); border: 1px solid var(--border); border-radius: 12px; padding: 1.75rem; display: flex; flex-direction: column; gap: 0.9rem; transition: all 0.25s; position: relative; overflow: hidden; }
        .proj-card::after { content: ''; position: absolute; inset: 0; background: linear-gradient(135deg, #1d4ed808 0%, transparent 50%); opacity: 0; transition: opacity 0.3s; pointer-events: none; }
        .proj-card:hover { border-color: var(--border2); transform: translateY(-3px); box-shadow: 0 12px 36px #00000044; }
        .proj-card:hover::after { opacity: 1; }
        .proj-top { display: flex; justify-content: space-between; align-items: flex-start; }
        .proj-ico { font-size: 1.5rem; }
        .proj-btns { display: flex; gap: 0.4rem; }
        .proj-btn { width: 30px; height: 30px; border: 1px solid var(--border2); border-radius: 6px; display: flex; align-items: center; justify-content: center; color: var(--muted); text-decoration: none; font-size: 0.78rem; transition: all 0.2s; }
        .proj-btn:hover { border-color: var(--accent2); color: var(--accent2); background: var(--accent-dim); }
        .proj-name { font-family: 'IBM Plex Sans', sans-serif; font-weight: 700; font-size: 1rem; color: var(--text); }
        .proj-desc { font-size: 0.875rem; line-height: 1.75; color: var(--muted2); flex: 1; }
        .proj-metrics { font-family: 'IBM Plex Mono', monospace; font-size: 0.75rem; color: var(--accent2); background: var(--accent-dim); border: 1px solid #3b82f628; border-radius: 5px; padding: 0.35rem 0.7rem; width: fit-content; }
        .proj-tags { display: flex; flex-wrap: wrap; gap: 0.4rem; }
        .proj-tag { font-family: 'IBM Plex Mono', monospace; font-size: 0.68rem; color: var(--muted); padding: 0.18rem 0.5rem; background: var(--bg3); border-radius: 3px; }
        .show-more { display: flex; justify-content: center; margin-top: 2.5rem; }
      `}</style>

      <section id="projects">
        <div className="wrap">
          <FadeIn><div className="sec-eyebrow">Selected Work</div></FadeIn>
          <FadeIn delay={0.05}>
            <h2 className="sec-title">Projects that <em>ship to production</em></h2>
          </FadeIn>
          <FadeIn delay={0.1}>
            <p className="sec-sub">
              Open-source tools and systems I've built — with real usage metrics, not just demos.
            </p>
          </FadeIn>

          <div className="proj-grid">
            {shown.map((p, i) => (
              <FadeIn key={p.title} delay={i * 0.07}>
                <div className="proj-card">
                  <div className="proj-top">
                    <div className="proj-ico">{p.icon}</div>
                    <div className="proj-btns">
                      {p.github && (
                        <a href={p.github} className="proj-btn" title="GitHub">⌥</a>
                      )}
                      {p.live && (
                        <a href={p.live} className="proj-btn" title="Live Demo">↗</a>
                      )}
                    </div>
                  </div>
                  <div className="proj-name">{p.title}</div>
                  <div className="proj-desc">{p.desc}</div>
                  {p.metrics && <div className="proj-metrics">{p.metrics}</div>}
                  <div className="proj-tags">
                    {p.tags.map((t) => (
                      <span key={t} className="proj-tag">{t}</span>
                    ))}
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>

          {extras.length > 0 && (
            <div className="show-more">
              <button className="btn-s" onClick={() => setShowAll(!showAll)}>
                {showAll ? "Show less" : `Show ${extras.length} more projects`}
              </button>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ProjectsSection;